// extracted by mini-css-extract-plugin
export default {"wrapper":"BundleProductContent-wrapper-mfQ","content":"BundleProductContent-content-zNg"};